/**
 * Creates empty event attributes for better comparison in the tracking post-processing.
 * @returns {EventAttributes} preconfigured empty event attributes
 */
export function makeEmptyEventAttributes() {
    return {
        componentName: '',
        label: '',
        targetURL: '',
        clickID: '',
        elementName: '',
        value: '',
        pos: '',
    };
}
